import { apiAxios } from "./api-config/axiosConfig";

interface LoginPayload {
  email: string;
  password: string;
}

export const authApis = {
  login: async (payload: LoginPayload) => {
    try {
      const response = await apiAxios.post("/inspector/login", payload);
      return response.data;
    } catch (error: any) {
      console.error("Login API Error:", error);
      throw error?.response?.data || error;
    }
  },

  oktaMe: async (oktaToken: string) => {
    try {
      const response = await apiAxios.get("/inspector/me", {
        headers: {
          Authorization: `Bearer ${oktaToken}`,
        },
      });
      return response.data;
    } catch (error: any) {
      console.error("Okta Inspector Me API Error:", error);
      throw error?.response?.data || error;
    }
  },

  logout: async () => {
    const token = localStorage.getItem("LVaccessToken");

    try {
      const res = await apiAxios.post(
        "/inspector/logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res?.data;
    } catch (error: any) {
      throw error?.response?.data || error;
    }
  },
};
